module.exports = __webpack_public_path__ + "static/img/3944_phase_function_Paper_PointsHejduk_Prediction.92567fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3944_phase_function_Paper_PointsHejduk_Prediction.png
// module id = +xvU
// module chunks = 0